import createSimpleReducers from '../Shared/ducks/createSimpleReducers'
const ducks = createSimpleReducers('Appointment')

export default ducks
